import RestaurantCard, { RestaurantCardProps } from './RestaurantCard';

export type { RestaurantCardProps };
export default RestaurantCard;
